import Seo from "@/components/site/Seo";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import Services from "@/components/site/Services";
import PopularServices from "@/components/site/PopularServices";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Process from "@/components/site/Process";
import Gallery from "@/components/site/Gallery";
import VideoGallery from "@/components/site/VideoGallery";
import ServiceAreas from "@/components/site/ServiceAreas";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import CtaBanner from "@/components/site/CtaBanner";
import ReviewNudge from "@/components/site/ReviewNudge";
import { FAQS } from "@/data/business";
import { CANONICAL_DOMAIN } from "@/data/cities";
import { faqSchema, websiteSchema, localBusinessSchema } from "@/data/schema";

export default function Home() {
  return (
    <>
      <Seo
        title="Prosper Garage Door Repair | 24/7 Repair in Prosper, TX"
        description="24/7 emergency garage door repair in Prosper, TX. Broken spring, opener, off-track & panel repair plus new installs. Same-day service across Collin County. Call (972) 742-3944."
        canonical={CANONICAL_DOMAIN + "/"}
        jsonLd={[websiteSchema(), localBusinessSchema(), faqSchema(FAQS)]}
      />
      <Hero />
      <TrustStrip />
      <Services />
      <PopularServices />
      <WhyChooseUs />
      <Process />
      <Gallery />
      <VideoGallery />
      <ServiceAreas />
      <Testimonials />
      <FAQ />
      <CtaBanner />
      <ReviewNudge />
    </>
  );
}
